export default function FourInARowIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="6" y="14" width="52" height="44" rx="7" fill="#3B434F" />
      {[0, 1, 2, 3].map((c) =>
        [0, 1, 2].map((r) => {
          const fill = r === 2 ? (c % 2 ? '#FF8A1F' : '#2F8BFF') : r === 1 && c === 1 ? '#2F8BFF' : r === 1 && c === 2 ? '#FF8A1F' : '#20242C';
          return <circle key={`${c}${r}`} cx={14.5 + c * 11.7} cy={23 + r * 13} r="4.8" fill={fill} />;
        }),
      )}
      <circle cx="26.2" cy="7" r="4.8" fill="#2F8BFF" />
    </svg>
  );
}
